var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7192 5.21642L6.12417 9.81142C5.56125 10.3743 4.79776 10.6906 4.00167 10.6906C3.20558 10.6906 2.44209 10.3743 1.87917 9.81142C1.31625 9.2485 1 8.48502 1 7.68892C1 6.89283 1.31625 6.12935 1.87917 5.56642L6.16417 1.28142C6.53945 0.905479 7.0487 0.694012 7.5799 0.693543C8.1111 0.693074 8.62072 0.903642 8.99667 1.27892C9.37261 1.6542 9.58408 2.16346 9.58455 2.69466C9.58502 3.22585 9.37445 3.73548 8.99917 4.11142L4.70417 8.39642C4.51653 8.58406 4.26203 8.68948 3.99667 8.68948C3.7313 8.68948 3.47681 8.58406 3.28917 8.39642C3.10153 8.20878 2.99611 7.95429 2.99611 7.68892C2.99611 7.42356 3.10153 7.16906 3.28917 6.98142L7.53417 2.74142",
    stroke: "#726C6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.81f0777ca7106e29749bf426bb2d19b4.svg";
export { ForwardRef as ReactComponent };